import { useContext, useMemo } from 'react'
import { useFirestoreGeneral, useFirestoreGeneralOrderBy } from '../../../firebase/useFirestore'
import Location from '../../../hooks/Location'
import { AdressNavigation } from '../../../StateManagment/AdressNavigation'
import { buildStreetLabelMap, streetLabel } from '../../../helpers/adressHelpers/buildStreetLabels'
import { HOUSEHOLD_FIELDS } from '../../../helpers/adressHelpers/householdFields'

/**
 * De kaart 'Primaire gegevens' op het overzicht van een huishouden. Leest de
 * vaste gegevens van het huishouden, en tot de migratie de oude regels —
 * dezelfde lezing als de lijst, dus ook een tweede telefoontitel en de
 * toevoeging. AI-CONTEXT: See docs/features/huishouden-vaste-gegevens.md (T9)
 */
const PrimaryDataCard = () => {
    const adressId = Location()[3]
    const [, setAdressNavigation] = useContext(AdressNavigation)

    const adressList = useFirestoreGeneral('Adresses', 'ID', adressId || '')
    const data = useFirestoreGeneralOrderBy(
        'PersonaData',
        'PersonaID',
        adressId || '',
        'Position',
        'asc'
    )

    const rows = useMemo(() => {
        const adress = Array.isArray(adressList) ? adressList[0] : null
        const map = buildStreetLabelMap(Array.isArray(data) ? data : [], adress ? [adress] : [])
        const entry = map[adressId] || {}
        return [
            { key: 'name', label: HOUSEHOLD_FIELDS.Naam.label, value: entry.Naam },
            { key: 'street', label: 'Adres', value: streetLabel(map, adressId, '') },
            { key: 'city', label: HOUSEHOLD_FIELDS.Postcode.label, value: [entry.Postcode, entry.Woonplaats].filter(Boolean).join(', ') },
            { key: 'phone', label: HOUSEHOLD_FIELDS.Telefoon.label, value: entry.Telefoon },
            { key: 'email', label: HOUSEHOLD_FIELDS.Email.label, value: entry.Email },
        ]
    }, [adressList, data, adressId])

    return (
        <div className="new-dashboard-card">
            <div className="new-dashboard-card-content">
                <h3 className="new-dashboard-card-title">Primaire gegevens</h3>
                <ul className="adress-dashboard-data-list">
                    {rows.map(field => (
                        <li key={field.key} className="adress-dashboard-data-row">
                            <span className="adress-dashboard-data-label">{field.label}</span>
                            <span className="adress-dashboard-data-value">{field.value || '—'}</span>
                        </li>
                    ))}
                </ul>
                <button
                    type="button"
                    className="adress-dashboard-view-all"
                    onClick={() => setAdressNavigation('data')}
                >
                    Bekijk alle gegevens →
                </button>
            </div>
        </div>
    )
}

export default PrimaryDataCard
